export const validateBusTime = (input: string | null): string | null => {
    // Return null for non-string input
    if (typeof input !== 'string') {
        return null
    }

    // Clean the input - remove whitespace
    const cleaned = input.trim()

    // Return null for empty string
    if (!cleaned) {
        return null
    }

    let hours, minutes

    // Check if input contains a colon
    if (cleaned.includes(':')) {
        const parts = cleaned.split(':')

        // Must have exactly 2 parts
        if (parts.length !== 2) {
            return null
        }

        hours = parts[0]
        minutes = parts[1]

        // For colon format, require proper formatting:
        // Hours: 1-2 digits, Minutes: exactly 2 digits
        if (!/^\d{1,2}$/.test(hours) || !/^\d{2}$/.test(minutes)) {
            return null
        }
    } else {
        // No colon - must be exactly 4 digits
        if (!/^\d{4}$/.test(cleaned)) {
            return null
        }

        // Format: HHMM (e.g., "0930")
        hours = cleaned.substring(0, 2)
        minutes = cleaned.substring(2, 4)
    }

    // Convert to numbers for range validation
    const h = parseInt(hours, 10)
    const m = parseInt(minutes, 10)

    // Validate ranges: hours 0-34, minutes 0-59
    if (h < 0 || h > 34 || m < 0 || m > 59) {
        return null
    }

    // Format as HH:MM (pad hours if needed, minutes already validated as 2 digits)
    const formattedHours = h.toString().padStart(2, '0')
    const formattedMinutes = minutes // Use original string to preserve leading zeros

    return `${formattedHours}:${formattedMinutes}`
}
